import { render } from "./Others22Charts.vue?vue&type=template&id=0daad4b2&scoped=true"
import script from "./Others22Charts.vue?vue&type=script&lang=js"
export * from "./Others22Charts.vue?vue&type=script&lang=js"

import "./Others22Charts.vue?vue&type=style&index=0&id=0daad4b2&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0daad4b2"]])

export default __exports__